import jwtDecode from "jwt-decode"
import { useEffect, useState } from "react"
import { useQueryClient } from "react-query"
import { useNavigate } from "react-router-dom"
import "./Error.css"

export default function Error({ error ,type }) {
  const [isExpired, setIsExpired] = useState(false)

  const queryClient = useQueryClient()

  useEffect(() => {
    // if token is invalid
    try {
      const decodedToken = jwtDecode(localStorage.getItem("token"))
      if (decodedToken.exp * 1000 < Date.now()) {
        setIsExpired(true)
      }
    } catch (e) {
      setIsExpired(true)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const errorString =
    "Something went wrong. If the problem persists, please contact us."
  const expiredString = "Your session has expired. Please sign in again."

  const navigate = useNavigate()

  const handleButtonClick = () => {
    if(type === "unauthorized")  {
     return navigate("/")
    }
    if (isExpired) {
      console.clear()
      localStorage.removeItem("token")
      queryClient.clear()
      navigate("/login")
    } else {
      navigate(-1)
    }
  }

  return (
    // <div className="h-[calc(100vh-116px)] flex flex-col justify-center gap-4 items-center">
    <div
      className="absolute top-0 left-0 z-[9999999999] flex h-full
    w-full flex-col items-center justify-center gap-4 bg-white"
    >
      <div className="">
        <svg
          className="Cog"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
        >
          <path d="M29.18 19.07c-1.678-2.908-.668-6.634 2.256-8.328L28.29 5.295c-.897.527-1.942.83-3.057.83-3.36 0-6.085-2.743-6.085-6.126h-6.29c.01 1.043-.25 2.102-.81 3.07-1.68 2.907-5.41 3.896-8.34 2.21L.566 10.727c.905.515 1.69 1.268 2.246 2.234 1.677 2.904.673 6.624-2.24 8.32l3.145 5.447c.895-.522 1.935-.82 3.044-.82 3.35 0 6.066 2.725 6.083 6.092h6.29c-.004-1.035.258-2.08.81-3.04 1.676-2.902 5.4-3.893 8.325-2.218l3.145-5.447c-.9-.515-1.678-1.266-2.232-2.226zM16 22.48c-3.578 0-6.48-2.902-6.48-6.48S12.423 9.52 16 9.52c3.578 0 6.48 2.902 6.48 6.48s-2.902 6.48-6.48 6.48z" />
        </svg>
      </div>
      <h1 className="text-center text-[22px] font-[600] text-neutral-1">
        {error ? error : "An error has occurred"}
      </h1>
      <p className="text-center text-[16px] text-neutral-2">
        {isExpired ? expiredString : error ? "" : errorString}
      </p>

      <button
        className="ml-4 rounded-[10px] border border-primary px-4 py-2 text-primary transition duration-500 ease-in-out hover:bg-primary hover:text-white"
        onClick={() => handleButtonClick(isExpired)}
      >
        {isExpired ? "Sign in again" : "Go back"}
      </button>
    </div>
  )
}
